import type { Tables } from "@msuite/utils/types";
import { Lightbox } from "../lightbox";
import type { GetFileAnnotations, SaveFileAnnotations } from "../lightbox/shared";
import type { RemoteFetchHookProps } from "./shared";

/** Props Interface */
interface FileInspectorInlineItemProps extends RemoteFetchHookProps {
	file: Tables<"files">;
	getAnnotations?: GetFileAnnotations;
	onSaveAnnotations?: SaveFileAnnotations;
	hasAnnotations?: boolean;
}

export function FileInspectorInlineItem({
	file,
	useRemoteFileUrl,
	getAnnotations,
	onSaveAnnotations,
	hasAnnotations,
}: FileInspectorInlineItemProps) {
	/** Hooks */
	const { signedUrl } = useRemoteFileUrl(file);

	/** Render */
	return (
		<Lightbox.Item
			src={signedUrl}
			width={file.width}
			height={file.height}
			contentType={file.contentType}
			fileName={file.fileName}
			id={file.id}
			getAnnotations={getAnnotations}
			onSaveAnnotations={onSaveAnnotations}
			hasAnnotations={hasAnnotations}
		/>
	);
}
